import OneOffOrders from "pages/oneofforders";
import OneOffOrderDetail from "pages/oneofforders/details";

const routes = [
  // Customers
  {
    path: `/one_off_orders`,
    exact: true,
    auth: true,
    component: OneOffOrders,
  },
  {
    path: `/one_off_order/:slotId`,
    exact: true,
    auth: true,
    component: OneOffOrderDetail,
  },
  // { path: `/order/:slotId`, exact: true, auth: true, component: OrderDetails },
  // { path: `/orders`, exact: true, auth: true, component: Orders },
];

export default routes;
